import { render, staticRenderFns } from "./mBanner.vue?vue&type=template&id=256684b1"
import script from "./mBanner.vue?vue&type=script&lang=js"
export * from "./mBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports